import React from 'react';
import { FEATURE_NAME } from 'utils/glossary';

/**
 * Copy for the offer-intent arrival coachmark and for the always-on tooltip on
 * the "Available to receive" row. One definition, two surfaces, so the flyout
 * and the tooltip can never drift apart — they are the same explanation, and
 * the tooltip is simply the version with nothing to dismiss.
 *
 * The body names the feature, so it reads FEATURE_NAME from the glossary rather
 * than re-typing the label the sidebar and page heading render.
 *
 * Copy states a condition that is already true ("With Available to receive on,
 * you're only seeing…") rather than instructing the user to go switch something
 * on: they arrive with the filter already applied, so an instruction would
 * describe a step they have not got to take.
 */

export const ARRIVAL_COACHMARK_HEADING = 'Find cards on offer';

export const ARRIVAL_COACHMARK_BODY = (
  <>
    With Available to receive on, you&apos;re only seeing cards people have listed for trade.
    Click on one and pick <strong>Make an offer</strong> to start a two-way trade in the{' '}
    {FEATURE_NAME}.
  </>
);

export const ARRIVAL_COACHMARK_BUTTON = 'Got it';

/**
 * Copy for the always-on tooltip on the "Available to send" row. The send side
 * has no coachmark — there is no send-intent arrival — so unlike the receive
 * copy above this has exactly one surface.
 *
 * "Refreshed every few minutes" is deliberate: the filter reads a set the
 * backend precomputes on a 15-minute cadence, so a brand-new want can take a
 * few minutes to appear here. Saying so in the tooltip is cheaper than a user
 * concluding the filter is broken. It stays vague rather than naming 15
 * minutes, so the copy does not go stale if the cadence changes.
 */
export const SEND_TOOLTIP_HEADING = 'Find cards to send';

export const SEND_TOOLTIP_BODY = (
  <>
    With Available to send on, you&apos;re only seeing cards other traders want and have the points
    to pay for. Click one to start a trade. It&apos;s the same pool your{' '}
    <strong>Send Cards</strong> page draws from, refreshed every few minutes.
  </>
);

/**
 * Mobile states the filtered condition in words instead of pointing at a rail
 * the user cannot see — below the rail breakpoint the filter lives inside a
 * closed sheet, so there is no visible anchor to name.
 */
export const ARRIVAL_COACHMARK_BODY_MOBILE =
  'These results are already filtered to cards people have listed for trade. Open one and pick Make an offer.';

export const ARRIVAL_COACHMARK_SECONDARY_MOBILE = 'Show me the filter';
